/* oxlint-disable max-lines */
// import used icons, see https://com/how-to-use/font-awesome-api#library-add
import { dom, library } from '@fortawesome/fontawesome-svg-core';

import {
  faAddressCard,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAnglesRight,
  faAngleUp,
  faArrowDown,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpShortWide,
  faBan,
  faBars,
  faBath,
  faBed,
  faBold,
  faBolt,
  faBook,
  faBookmark,
  faBug,
  faBuilding,
  faBuildingCircleXmark,
  faBullhorn,
  faCakeCandles,
  faCalculator,
  faCalendarDays,
  faCamera,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleMinus,
  faCirclePlus,
  faCircleXmark,
  faCloud,
  faCloudSun,
  faCodeBranch,
  faComments,
  faCompass,
  faCompress,
  faCreditCard,
  faDatabase,
  faDownload,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExpand,
  faFile,
  faFileAudio,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileSignature,
  faFileVideo,
  faFileWord,
  faFireFlameSimple,
  faFolder,
  faFolderOpen,
  faForward,
  faGear,
  faGrip,
  faGripVertical,
  faHandshake,
  faHardHat,
  faHouse,
  faImages,
  faInbox,
  faInfo,
  faItalic,
  faKey,
  faKeyboard,
  faLaughBeam,
  faLayerGroup,
  faLightbulb,
  faLink,
  faLinkSlash,
  faList,
  faListOl,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMinus,
  faMousePointer,
  faNoteSticky,
  faPalette,
  faPaperPlane,
  faPencilRuler,
  faPenToSquare,
  faPercentage,
  faPlus,
  faPoll,
  faQuestion,
  faReceipt,
  faReply,
  faRightFromBracket,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faRuler,
  faSave,
  faBell as fasBell,
  faCalendar as fasCalendar,
  faCircleQuestion as fasCircleQuestion,
  faComment as fasComment,
  faExclamationCircle as fasExclamationCircle,
  faFileLines as fasFileLines,
  faShare,
  faSliders,
  faSort,
  faPhone as fasPhone,
  faSpinner,
  faTriangleExclamation as fasTriangleExclamation,
  faStrikethrough,
  faUpload as fasUpload,
  faTable,
  faTag,
  faTh,
  faTimeline,
  faTimesCircle,
  faToggleOff,
  faTrashCan,
  faUmbrellaBeach,
  faUnderline,
  faUnlock,
  faUser,
  faUserGroup,
  faUserLarge,
  faUserLock,
  faUserPlus,
  faUsers,
  faUserSecret,
  faUserTie,
  faVideo,
  faWarehouse,
  faWater,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

import {
  faAlarmClock,
  faArrowLeftToLine,
  faArrowRightToLine,
  faArrowUpRightFromSquare,
  faChartTreeMap,
  faCircleCheck,
  faDiagramNested,
  faDownLeftAndUpRightToCenter,
  faExpandWide,
  faGrid2,
  faGridHorizontal,
  faHousePersonLeave,
  faLocationCheck,
  faPaperclipVertical,
  faPartyHorn,
  faPersonDolly,
  faPersonToPortal,
  faRocketLaunch,
  faCircleInfo as fasCircleInfo,
  faShuffle,
  faLayerPlus as fasLayerPlus,
  faSquareCheck as fasSquareCheck,
  faStars,
  faUpRightAndDownLeftFromCenter,
  faUserHelmetSafety,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBellSlash,
  faCheckCircle,
  faClock,
  faCopy,
  faEye,
  faEyeSlash,
  faFrown,
  faNewspaper,
  faBell as farBell,
  faCalendar as farCalendar,
  faCircleQuestion as farCircleQuestion,
  faCircleXmark as farCircleXmark,
  faComment as farComment,
  faRegistered,
  faFileLines as farFileLines,
  faSave as farSave,
  faSquareCheck,
  faThumbsUp,
} from '@fortawesome/free-regular-svg-icons';

import {
  faBarsFilter,
  faBee,
  faBoxArchive,
  faCheckToSlot,
  faClipboardList,
  faCommentSlash,
  faDolly,
  faExternalLink,
  faGarage,
  faHeartCrack,
  faHeat,
  faHighlighter,
  faHouseCircleCheck,
  faMemo,
  faMemoPad,
  faNote,
  faPen,
  faPersonDigging,
  faAlarmClock as farAlarmClock,
  faArrowLeft as farArrowLeft,
  faArrowRight as farArrowRight,
  faBars as farBars,
  faBath as farBath,
  faBed as farBed,
  faBold as farBold,
  faBolt as farBolt,
  faBookmark as farBookmark,
  faBuilding as farBuilding,
  faCalculator as farCalculator,
  faCheck as farCheck,
  faCircleInfo as farCircleInfo,
  faCirclePlus as farCirclePlus,
  faCloudSun as farCloudSun,
  faColumns3 as farColumns3,
  faCompass as farCompass,
  faCreditCard as farCreditCard,
  faEllipsis as farEllipsis,
  faEllipsisVertical as farEllipsisVertical,
  faEnvelope as farEnvelope,
  faEnvelopeCircleCheck as farEnvelopeCircleCheck,
  faEuroSign as farEuroSign,
  faExclamation as farExclamation,
  faExclamationCircle as farExclamationCircle,
  faFireFlameSimple as farFireFlameSimple,
  faFolderOpen as farFolderOpen,
  faGear as farGear,
  faGridHorizontal as farGridHorizontal,
  faGripDotsVertical as farGripDotsVertical,
  faHandshake as farHandshake,
  faHighlighter as farHighlighter,
  faHourglass as farHourglass,
  faHouse as farHouse,
  faHouseChimneyHeart as farHouseChimneyHeart,
  faImage as farImage,
  faInfo as farInfo,
  faItalic as farItalic,
  faLightbulb as farLightbulb,
  faLink as farLink,
  faList as farList,
  faListOl as farListOl,
  faLocationDot as farLocationDot,
  faLock as farLock,
  faLockOpen as farLockOpen,
  faMinus as farMinus,
  faMobile as farMobile,
  faPaperclipVertical as farPaperclipVertical,
  faPenToSquare as farPenToSquare,
  faPercentage as farPercentage,
  faPersonDolly as farPersonDolly,
  faPhone as farPhone,
  faPlus as farPlus,
  faReceipt as farReceipt,
  faRotateLeft as farRotateLeft,
  faRotateRight as farRotateRight,
  faRuler as farRuler,
  faSliders as farSliders,
  faSpinner as farSpinner,
  faStrikethrough as farStrikethrough,
  faTable as farTable,
  faTag as farTag,
  faTimesCircle as farTimesCircle,
  faTrashCan as farTrashCan,
  faTriangleExclamation as farTriangleExclamation,
  faUnderline as farUnderline,
  faUnlock as farUnlock,
  faUpload as farUpload,
  faUser as farUser,
  faUserGroup as farUserGroup,
  faUserHelmetSafety as farUserHelmetSafety,
  faUserLarge as farUserLarge,
  faWater as farWater,
  faXmark as farXmark,
  faSignature,
  faStore,
  faThumbtack,
} from '@fortawesome/pro-regular-svg-icons';

import { faGoogleDrive, faHubspot, faIntercom, faSalesforce } from '@fortawesome/free-brands-svg-icons';

import { faCalendarCheck, faSadTear } from '@fortawesome/pro-duotone-svg-icons';

import { faFilePlus, faReceipt as falReceipt, faXmark as falXmark } from '@fortawesome/pro-light-svg-icons';

library.add(
  faAddressCard,
  faAlarmClock,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAnglesRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowDownWideShort,
  faArrowUpShortWide,
  faArrowLeftToLine,
  faArrowRightToLine,
  faArrowLeft,
  faArrowRight,
  farArrowRight,
  faArrowUp,
  faBan,
  faBars,
  farBars,
  faBarsFilter,
  faBath,
  faBed,
  faBee,
  faBellSlash,
  faBold,
  faBolt,
  faBoxArchive,
  faBook,
  faBug,
  faBuilding,
  faBullhorn,
  faCakeCandles,
  faCalculator,
  faCalendarCheck,
  faCalendarDays,
  faCamera,
  faCaretDown,
  faChartBar,
  faChartTreeMap,
  farCheck,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faSquareCheck,
  fasSquareCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCirclePlus,
  faCircleXmark,
  farCircleXmark,
  farUser,
  farPersonDolly,
  farBuilding,
  farUserLarge,
  farUserGroup,
  faClipboardList,
  farGridHorizontal,
  faClock,
  faCloud,
  faCloudSun,
  faCodeBranch,
  faGear,
  farColumns3,
  farTrashCan,
  farGear,
  faComments,
  faCompass,
  faCopy,
  faQuestion,
  farLightbulb,
  faCreditCard,
  faDatabase,
  faDiagramNested,
  faDolly,
  faDownload,
  faPenToSquare,
  faEllipsis,
  farAlarmClock,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  farEnvelopeCircleCheck,
  farCalculator,
  farUserHelmetSafety,
  farEuroSign,
  faExpandWide,
  faExternalLink,
  faEye,
  farLock,
  faEyeSlash,
  faFile,
  faFileExcel,
  faFilePdf,
  faFilePlus,
  faFilePowerpoint,
  faFileSignature,
  faFileWord,
  faFileVideo,
  faFileAudio,
  faFileImage,
  faFireFlameSimple,
  faFolder,
  faFolderOpen,
  farFolderOpen,
  faForward,
  faFrown,
  faGarage,
  faGoogleDrive,
  faGrip,
  farHourglass,
  faGripVertical,
  faHandshake,
  faHardHat,
  faHeartCrack,
  faHighlighter,
  faHouse,
  faHouseCircleCheck,
  faHubspot,
  faImages,
  faInbox,
  farInfo,
  faInfo,
  faIntercom,
  faItalic,
  faKey,
  faThumbtack,
  faKeyboard,
  faLaughBeam,
  faLightbulb,
  farLockOpen,
  faLink,
  faList,
  faGrid2,
  faListOl,
  faLocationCheck,
  faLocationDot,
  faLock,
  falReceipt,
  farMinus,
  faMinus,
  faCircleMinus,
  faMemo,
  faMemoPad,
  faMousePointer,
  faNewspaper,
  faPalette,
  faPaperclipVertical,
  faPaperPlane,
  farTag,
  faCheckToSlot,
  faPartyHorn,
  faPen,
  faPencilRuler,
  faPercentage,
  faPersonDigging,
  faPersonDolly,
  faHousePersonLeave,
  faPersonToPortal,
  fasPhone,
  faPlus,
  faPoll,
  farBell,
  farCalendar,
  farComment,
  faReply,
  faReceipt,
  faRotateRight,
  faRegistered,
  farExclamation,
  farExclamationCircle,
  farTriangleExclamation,
  farPlus,
  farFileLines,
  farHouseChimneyHeart,
  farCircleInfo,
  faRocketLaunch,
  farCircleQuestion,
  farReceipt,
  farSave,
  farTimesCircle,
  faRuler,
  farUpload,
  faSadTear,
  faSalesforce,
  faSave,
  fasBell,
  fasCalendar,
  fasComment,
  faMagnifyingGlass,
  fasExclamationCircle,
  fasTriangleExclamation,
  fasFileLines,
  faShare,
  faShuffle,
  faSignature,
  faRightFromBracket,
  fasCircleInfo,
  fasLayerPlus,
  faSliders,
  faSort,
  faArrowDownWideShort,
  faSpinner,
  fasCircleQuestion,
  faNoteSticky,
  faStrikethrough,
  fasUpload,
  faStars,
  faRotate,
  faStore,
  faTable,
  faTag,
  faTh,
  faToggleOff,
  faGridHorizontal,
  faThumbsUp,
  faXmark,
  falXmark,
  faTimeline,
  faTimesCircle,
  faTrashCan,
  faUnderline,
  faRotateLeft,
  faLinkSlash,
  faUnlock,
  faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter,
  faArrowUpRightFromSquare,
  faUser,
  faUserLarge,
  faUserGroup,
  faUserHelmetSafety,
  faUserLock,
  faUserPlus,
  faUsers,
  faUserSecret,
  faUserTie,
  faVideo,
  faWarehouse,
  faWater,
  faCompress,
  faExpand,
  farBold,
  farItalic,
  farStrikethrough,
  farUnderline,
  farHighlighter,
  farList,
  farListOl,
  farLink,
  farXmark,
  faNote,
  farRotateLeft,
  farRotateRight,
  farPaperclipVertical,
  farMobile,
  farEllipsisVertical,
  farEllipsis,
  farImage,
  faCommentSlash,
  farTable,
  farPenToSquare,
  farHouse,
  farPhone,
  farEnvelope,
  farArrowLeft,
  faLayerGroup,
  faBookmark,
  farBookmark,
  farLocationDot,
  farRuler,
  farCompass,
  farHandshake,
  farPercentage,
  farBed,
  farBath,
  farCloudSun,
  farWater,
  farFireFlameSimple,
  farBolt,
  farCirclePlus,
  farCreditCard,
  farSpinner,
  farUnlock,
  faHeat,
  farGripDotsVertical,
  farSliders,
  faBuildingCircleXmark,
  faUmbrellaBeach,
);

dom.watch();
